import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useTagsApi() {
    const callApi = useApiCall();

    return {
        addUpdateTag: apiCaller(callApi, SAGA_ACTIONS.TAGS.ADD_UPDATE_TAG),
        deleteTag: apiCaller(callApi, SAGA_ACTIONS.TAGS.DELETE_TAG),
        searchTag: apiCaller(callApi, SAGA_ACTIONS.TAGS.SEARCH_TAG),
        tagDetails: apiCaller(callApi, SAGA_ACTIONS.TAGS.TAG_DETAILS),
    };
}
